import { call, put, takeLatest } from "redux-saga/effects";
import {getTopFilterData} from "../services/globalFilter/globalFilter.service";
import {GLOBALFILTER_DATA_REQUEST} from "../actions/actionTypes";
import {getGlobalFilterDataError, getGlobalFilterDataSuccess} from "../actions/GlobalFilter/globalFilterActions";


export function* fetchTopFilterData(action: any) {
  try {
    const payload = action?.payload || {};
    const response = yield call(getTopFilterData, payload);
    yield put(getGlobalFilterDataSuccess(response?.Data));
  } catch (error: any) {
    yield put(getGlobalFilterDataError({
      message: error?.message || 'Unknown error occurred while fetching quick filters.',
      stack: error?.stack || '',
      source: 'fetchTopFilterData'
    }));
    console.error('Error fetching quick filters:', error);
  }
}
export function* globalFilterSaga() {
  yield takeLatest(GLOBALFILTER_DATA_REQUEST, fetchTopFilterData);
}